<template>
  <div class="cm-page">
    <header ref="page_header" class="cm-page__header">
      <slot name="page-header">

      </slot>
      <div class="cm-page__buttons">
        <slot name="page-buttons">

        </slot>
      </div>
    </header>
    <div class="cm-page__content">
      <slot name="page-content">

      </slot>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss">
.cm-page {
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  flex-grow: 0;
  height: 100%;
  &__header {
    // flex: 0 1 auto;
    padding: 12px $regular-space 0;
    h1 {
      margin-bottom: 0;
    }
    .toolbar {
      padding-top: 0;
    }
  }
  &__description {
    color: $color_text_light;
  }
  &__buttons {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__content {
    flex-grow: 1;
  }
}
</style>
